function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import IconRemove from '../icons/Close';
import Button from '../Button';
export const PopupFieldLabel = styled.label.withConfig({
  displayName: "Popup__PopupFieldLabel",
  componentId: "sc-1w264wc-0"
})(["line-height:21px;font:inherit;font-size:0.875rem;font-weight:bold;padding:20px 0 10px 0;align-self:flex-start;text-align:left;"]);
const Backdrop = styled.div.withConfig({
  displayName: "Popup__Backdrop",
  componentId: "sc-1w264wc-1"
})(["position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(196,196,196,0.5);pointer-events:auto;overflow-x:hidden;overflow-y:auto;z-index:", ";"], _ref => {
  let {
    zIndex = 99
  } = _ref;
  return zIndex;
});
const Wrapper = styled.div.withConfig({
  displayName: "Popup__Wrapper",
  componentId: "sc-1w264wc-2"
})(["position:relative;padding:2em;padding-bottom:1em;border-radius:4px;background-color:white;box-shadow:0px 8px 32px rgba(0,0,0,0.12);border-radius:4px;width:", ";text-align:center;", ""], props => props.width ? props.width : '600px', props => !props.isCentered ? 'margin: 10% auto;' : css(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);"]));
const CloseButton = styled(Button).attrs({
  type: 'outline'
}).withConfig({
  displayName: "Popup__CloseButton",
  componentId: "sc-1w264wc-3"
})(["border-color:transparent;position:absolute;top:2px;right:2px;padding:1px 8px;height:auto;i.iconLeft{color:#999999;margin-right:0;}"]);
class Popup extends React.PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "fadeIn", () => {
      this.setState({
        isOpen: true
      }, () => {
        setTimeout(() => {
          this.setState({
            opacity: 1
          });
        }, 10);
      });
    });
    _defineProperty(this, "fadeOut", () => {
      this.setState({
        opacity: 0
      }, () => {
        setTimeout(() => {
          this.setState({
            isOpen: false
          });
        }, 300);
      });
    });
    _defineProperty(this, "onBackdropClick", event => {
      const {
        onRequestClose,
        hideOnBackdropClick
      } = this.props;
      if (!hideOnBackdropClick) return;
      if (event.target.dataset.modal && onRequestClose instanceof Function) {
        onRequestClose();
      }
    });
    _defineProperty(this, "onClose", () => {
      if (this.props.onRequestClose) {
        this.props.onRequestClose();
      }
      if (this.props.onClose) {
        this.props.onClose();
      }
    });
    const {
      isOpen
    } = props;
    this.state = {
      opacity: isOpen ? 1 : 0,
      isOpen
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      isOpen
    } = this.props;
    if (isOpen !== nextProps.isOpen) {
      if (nextProps.isOpen === true) {
        this.fadeIn();
      } else {
        this.fadeOut();
      }
    }
  }
  render() {
    const _this$props = this.props,
      {
        className,
        children,
        isCentered,
        hideCloseButton,
        zIndex
      } = _this$props,
      other = _objectWithoutProperties(_this$props, ["className", "children", "isCentered", "hideCloseButton", "zIndex"]);
    const _this$state = this.state,
      {
        isOpen
      } = _this$state,
      animationStyle = _objectWithoutProperties(_this$state, ["isOpen"]);
    if (!isOpen) return null;
    return ReactDOM.createPortal(React.createElement(Backdrop, {
      isCentered: isCentered,
      zIndex: zIndex,
      style: _objectSpread({}, animationStyle),
      onClick: this.onBackdropClick,
      "data-modal": true
    }, React.createElement(Wrapper, _extends({
      isCentered: isCentered,
      className: className
    }, other), !hideCloseButton && React.createElement(CloseButton, {
      onClick: this.onClose
    }, React.createElement(IconRemove, {
      size: 16
    })), children)), document.body);
  }
}
_defineProperty(Popup, "propTypes", {
  isOpen: PropTypes.bool.isRequired,
  isCentered: PropTypes.bool,
  hideCloseButton: PropTypes.bool,
  onRequestClose: PropTypes.func,
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
  theme: PropTypes.shape({}).isRequired,
  hideOnBackdropClick: PropTypes.bool,
  className: PropTypes.string,
  zIndex: PropTypes.number
});
_defineProperty(Popup, "defaultProps", {
  className: '',
  isCentered: false,
  hideCloseButton: false,
  hideOnBackdropClick: false,
  onRequestClose: () => {},
  onClose: () => {}
});
export default Popup;